import { Link, useOutletContext } from "react-router";
import { Button } from "@mui/material";
import { LabsCard } from "../LabsCard.tsx";
import { RecommendationsList } from "../RecommendationsList.tsx";
import { DashboardPanelOutlet } from "../../types/DashboardPanelOutlet.ts";

export const RecommendationsPanel = () => {
  const { analyzedPlan } = useOutletContext<DashboardPanelOutlet>();

  return (
    <LabsCard>
      <RecommendationsList recommendations={analyzedPlan.recommendations} />
      <Button
        variant={"outlined"}
        component={Link}
        to={"/dashboard/email-plan"}
      >
        Get your plan
      </Button>
    </LabsCard>
  );
};
